import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Box from '@mui/material/Box';
import MoreIcon from '@mui/icons-material/MoreVert';
import Divider from '@mui/material/Divider';
import { useQuery } from '../hooks/useQuery';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import HelpIcon from '@mui/icons-material/Help';
import { encryptData } from '../utils';

export const AppBarTop = ({ pages, onClickToolBar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, isUsuarioSebrae } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElNotification, setAnchorElNotification] = React.useState(null);
  const [countNotifications, setCountNotifications] = React.useState(0);
  const [notificacoes, setNotificacoes] = React.useState([]);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMenuNotificationOpen = Boolean(anchorElNotification);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const { listarNotificacoesNaoLidas, marcarComoLida } = useQuery();

  React.useEffect(() => {
    // execute on location change
    getNotifications();
  }, [location]);

  const getNotifications = async () => {
    const result = await listarNotificacoesNaoLidas();
    setNotificacoes(result.data.data);
    setCountNotifications(result.data.data.length);
  };

  const marcarNotificacaoComoLida = async (res) => {
    const result = await marcarComoLida(res.id);
    if (
      res.type == 'App\\Notifications\\NotaSituacaoNotification' ||
      res.type == 'App\\Notifications\\NotaErroNotification'
    ) {
      const encrypted = encryptData(
        JSON.stringify({
          contrato: res.data.contrato,
          cnpj: res.fornecedor,
          contrato_dts: res.data.contrato_dts,
          is_contract: true,
          gestor: res.data.gestor,
        }),
      );

      window.location.href = `/dashboard/notas/${encrypted}`;
    } else if (
      res.type == 'App\\Notifications\\ProtocoloFornecedorNotification'
    ) {
      window.location.href = `/dashboard/meus-dados`;
    } else {
      window.location.href = `/dashboard/informe-rendimentos`;
    }
  };

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotificationMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNotification(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMenuNotificationClose = () => {
    setAnchorElNotification(null);
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const drawerWidth = 240;

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {!isUsuarioSebrae && user.role_id != 3 ? (
        <>
          <MenuItem
            onClick={() => {
              navigate('/dashboard/meus-dados');
              setAnchorEl(null);
            }}
          >
            Meus dados
          </MenuItem>
          <MenuItem
            onClick={() => {
              navigate('/dashboard/meus-dados-bancarios');
              setAnchorEl(null);
            }}
          >
            Dados bancários
          </MenuItem>

          <Divider sx={{ my: 0.5 }} />
        </>
      ) : null}

      <MenuItem onClick={logout}>Sair</MenuItem>
    </Menu>
  );

  const renderMenuNotifications = (
    <Menu
      style={{ maxHeight: 300 }}
      anchorEl={anchorElNotification}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuNotificationOpen}
      onClose={handleMenuNotificationClose}
    >
      {notificacoes && notificacoes.length > 0
        ? notificacoes.map((res, idx) => {
            return (
              <Box key={`${idx}-appbar-top`}>
                <MenuItem
                  onClick={() => {
                    setAnchorElNotification(null);
                    marcarNotificacaoComoLida(res);
                  }}
                >
                  {res.type ==
                  'App\\Notifications\\NotaSituacaoNotification' ? (
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                      <NotificationsActiveIcon
                        color="primary"
                        style={{ marginRight: 10 }}
                      />{' '}
                      A nota {res.data.numero_nf} teve uma alteração de status.
                    </Box>
                  ) : null}
                  {res.type ==
                  'App\\Notifications\\ProtocoloFornecedorNotification' ? (
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                      <NotificationsActiveIcon
                        color="primary"
                        style={{ marginRight: 10 }}
                      />{' '}
                      O seu protocolo vence em {res.data.days} dias, atualize
                      seu cadastro.
                    </Box>
                  ) : null}
                  {res.type == 'App\\Notifications\\NotaErroNotification' ? (
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                      <NotificationsActiveIcon
                        color="error"
                        style={{ marginRight: 10 }}
                      />{' '}
                      Houve um erro ao processar a nota {res.data.numero_nf},
                      verifique com seu gestor.
                    </Box>
                  ) : null}
                  {res.type ==
                  'App\\Notifications\\InformeRendimentoNotification' ? (
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                      <NotificationsActiveIcon
                        color="primary"
                        style={{ marginRight: 10 }}
                      />{' '}
                      O Informe Rendimentos do ano de {res.data.ano} foi
                      atualizado.
                    </Box>
                  ) : null}
                </MenuItem>
                <Divider sx={{ my: 0.5 }} />
              </Box>
            );
          })
        : null}
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={countNotifications} color="error">
            <NotificationsIcon color="primary" />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        color={'inherit'}
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="primary"
            aria-label="open drawer"
            edge="start"
            onClick={onClickToolBar}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>

          <Box sx={{ flexGrow: 1 }}>{process.env.REACT_APP_AMBIENTE}</Box>
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <IconButton
              size="large"
              edge="end"
              title="Faq"
              aria-label="account of current user"
              aria-haspopup="true"
              onClick={() => {
                navigate('faq');
              }}
              color="inherit"
            >
              <HelpIcon color="primary" />
            </IconButton>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleNotificationMenuOpen}
              color="inherit"
            >
              <Badge badgeContent={countNotifications} color="error">
                <NotificationsIcon color="primary" />
              </Badge>
            </IconButton>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle color={'primary'} />
              <span style={{ fontSize: 16, marginLeft: 10, color: '#0e72b8' }}>
                {user && user.nome_usuario.split(' ')[0]}
              </span>
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      {renderMenuNotifications}
    </Box>
  );
};
